import type {
	ICreateElectionCycleState,
	IElectionCycleByIDState,
	IElectionCycleStates,
} from '../../../interface/state/IElectionState';
import { electionCycleType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, updateAPI } from '../api-utils';

export interface ICreateElectionCycle {
	year?: string;
	electionTypeId: number;
	daysUntilNotification: number;
	name: string;
	startDate: string;
	endDate: string;
	isSpecialElection: boolean;
	isActive: boolean;
}

export interface IUpdateElectionCycle {
	id: number;
	name: string;
	isActive: boolean;
	isSpecialElection: boolean;
	endDateUpdateReason: string;
	startDate: string;
	endDate: string;
	electionTypeId: number;
}

export const create = createAPI<ICreateElectionCycleState, ICreateElectionCycle>({
	actionType: electionCycleType.create,
	url: '/api/v1/ElectionCycle',
});

export const get = getAPI<IElectionCycleStates>({
	actionType: electionCycleType.get,
	url: '/api/v1/ElectionCycle',
	type: 'core',
});

export const getByID = getByIdAPI<IElectionCycleByIDState>({
	actionType: electionCycleType.getByID,
	url: '/api/v1/ElectionCycle',
});

export const getByName = getByNameAPI({
	actionType: electionCycleType.getByName,
	url: '/api/v1/ElectionCycle/name',
});

export const update = updateAPI<undefined, IUpdateElectionCycle>({
	actionType: electionCycleType.update,
	url: '/api/v1/ElectionCycle/update',
});

export const deleteById = deleteByIdAPI({
	actionType: electionCycleType.deleteById,
	url: '/api/v1/ElectionCycle/delete',
});
